export default __webpack_public_path__ + "static/media/vkpic6.d2475be8.png";